var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountFormSubscriptionsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    fill: "none",
    focusable: "false",
    height: 20,
    stroke: "none",
    viewBox: "0 0 20 20",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.421 16.9225H4.58039C3.4919 16.9225 2.60938 16.0806 2.60938 15.0421V8.46094L10.0007 11.7515L17.392 8.46094V15.0421C17.392 16.0806 16.5095 16.9225 15.421 16.9225Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M14.472 2.50781H5.53236C4.98356 2.50781 4.53906 2.90359 4.53906 3.39224V8.25661L10.0022 10.4677L15.4653 8.25661V3.39224C15.4653 2.90359 15.0208 2.50781 14.472 2.50781ZM12.4855 6.92993H7.51896C7.24481 6.92993 7.02231 6.73182 7.02231 6.48771C7.02231 6.24361 7.24481 6.0455 7.51896 6.0455H12.4855C12.7596 6.0455 12.9821 6.24361 12.9821 6.48771C12.9821 6.73182 12.7596 6.92993 12.4855 6.92993ZM7.51896 5.16109H12.4855C12.7596 5.16109 12.9821 4.96297 12.9821 4.71887C12.9821 4.47477 12.7596 4.27666 12.4855 4.27666H7.51896C7.24481 4.27666 7.02231 4.47477 7.02231 4.71887C7.02231 4.96297 7.24481 5.16109 7.51896 5.16109Z",
    fill: "currentColor",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountFormSubscriptionsIcon);
export default __webpack_public_path__ + "static/media/AccountFormSubscriptionsIcon.a508f2d4d559d6aca369ddb578fabb04.svg";
export { ForwardRef as ReactComponent };